(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-collection-cards"] && !Shopify.designMode) return;
  try {
    
  function setupMegaCollectionCards() {
    document.querySelectorAll('.mega-collection-cards__rail-wrap').forEach(function(wrap) {
      if (wrap.dataset.megaCollectionCardsReady === 'true') return;
      var rail = wrap.querySelector('[data-mega-collection-rail]');
      var prev = wrap.querySelector('[data-mega-collection-prev]');
      var next = wrap.querySelector('[data-mega-collection-next]');
      if (!rail || !prev || !next) return;
      function scrollCards(direction) {
        var card = rail.querySelector('.mega-collection-cards__card');
        var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 24;
        var amount = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
        rail.scrollBy({ left: amount * direction, behavior: 'smooth' });
      }
      prev.addEventListener('click', function(event) {
        event.preventDefault();
        scrollCards(-1);
      });
      next.addEventListener('click', function(event) {
        event.preventDefault();
        scrollCards(1);
      });
      wrap.dataset.megaCollectionCardsReady = 'true';
    });
  }

  setupMegaCollectionCards();
  document.addEventListener('shopify:section:load', setupMegaCollectionCards);

  } catch(e) { console.error(e); }
})();
})();
